import React, { useState } from "react";
import styles from "./RequestForUpdateStyles.module.css";
import { Modal, ModalBody } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { Actions } from "../../../Action";
import { seekerFollowUp } from "../../../API/api";
import { recommendData } from "../../../Action/actions";
import { replaceContentEditableText } from "../../../utils";
import { toast } from "react-toastify";
import AttachmentBox from "../../AttachmentBox/AttachmentBox";
import { Spin } from "antd";
import Button from "../../../NewComponent/Button/Button";
import Button2 from "../../../NewComponent/Button2/Button2";
import { ModalHeader } from "../../../Constants";
import Styles from './RequestForUpdateStyles.module.css'
export default function FollowUpModal2() {
    const modalState = useSelector((state) => state.domain);
    const dispatch = useDispatch();
    const { advanceFilterModalToggle } = bindActionCreators(Actions, dispatch);
    const answeredState = useSelector(state => state.answeredQuestions);
    const [text, setText] = useState('');
    const selectedAns = useSelector((state) => state.search);
    const answeredTabData = useSelector((state) => state.answeredQuestions)
    const [isLoading, setLoading] = useState(false);

    const onChangeAdditionalTextFollowUp = (e) => {
        setText(e.target.value);
    }

    const followUpToast = () => {
        return (
            <>
                <span style={{ fontSize: "12px" }}>
                    Your request for Follow-Up has been submitted successfully.
                </span>
            </>
        );
    };

    const followUpPayloadData = () => {
        setLoading(true);
        const obj = {
            answerUuid: selectedAns.selectedAnswer.answerUuid,
            additionalContext: text,
            originalExpert: true
        }
        seekerFollowUp(obj).then((res) => {
            if (res === undefined) return;
            if (res.data.success || res.data.data !== undefined) {
                // let newState = answeredState.data.filter(objj=>{
                //     objj.answers.filter(ans=>{
                //         if(ans.answerUuid === obj.answerUuid){
                //             ans.userInitiatedCuration = true;
                //         }
                //     })
                // })
                answeredState.data2.filter(objj => {
                    objj.answersList.filter(ans => {
                        if (ans.answerUuid === obj.answerUuid) {
                            ans.userInitiatedCuration = true;
                        }
                    })
                })
                advanceFilterModalToggle({ bool: false, value: "" })
                setLoading(false);
                toast.success(followUpToast(), {
                    position: toast.POSITION.TOP_RIGHT,
                });
            }
        }).catch((err) => console.log(err));
    }

    const askTheTeamPayloadData = () => {
        setLoading(true);
        const obj = {
            answerUuid: selectedAns.selectedAnswer.answerUuid,
            additionalContext: text,
            originalExpert: false,
        }
        seekerFollowUp(obj).then((res) => {
            if (res === undefined) return;
            if (res.data.success || res.data.data !== undefined) {
                let newState = answeredState.data2.filter(objj => {
                    objj.answersList.filter(ans => {
                        if (ans.answerUuid === obj.answerUuid) {
                            ans.userInitiatedCuration = true;
                        }
                    })
                    return objj;
                })
                advanceFilterModalToggle({ bool: false, value: "" });
                setLoading(false);
                toast.success(followUpToast(), {
                    position: toast.POSITION.TOP_RIGHT,
                });
            }
        }).catch((err) => console.log(err));

    }
    return (
        <Modal
            show={modalState.modalState}
            onHide={() => advanceFilterModalToggle({ bool: false, value: "" })}
            centered={true}
            size={"lg"}
            dialogClassName={styles.modalDialog}

        >
            <Modal.Header closeButton>
                <Modal.Title style={ModalHeader.styles}>
                    <span className="fa fa-users" id={styles.modalUsers}></span>
                    &nbsp;&nbsp;Request for Follow-Up
                </Modal.Title>
            </Modal.Header>
            <ModalBody>
                <Spin spinning={isLoading}>
                    <div className="col-md-12 col-lg-12">
                        <h2 className={`mb-3`} style={ModalHeader.questionText}>
                            {selectedAns.selectedQuestion.text}
                        </h2>
                        {
                            answeredTabData.seekerAttachments && answeredTabData.seekerAttachments.length > 0 &&
                            (
                                answeredTabData.seekerAttachments.map((obj, ind) => {
                                    return (
                                        <AttachmentBox attachment={obj} key={ind} />
                                    )
                                })
                            )
                        }
                        <div className={Styles.answerText} dangerouslySetInnerHTML={{ __html: replaceContentEditableText(selectedAns.selectedAnswer.answer) }} ></div>
                        {/* <div style={ModalHeader.answerText} dangerouslySetInnerHTML={{ __html: replaceContentEditableText(selectedAns.selectedAnswer.answer) }} ></div> */}
                        <p className={styles.followUpBranding}>Follow-up reason?</p>
                        <textarea style={{ width: "100%", borderRadius: "6px", padding: "5px", fontSize: "14px", outline: "none", borderColor: 'lightgrey' }} placeholder="Share with Expert your reason for request for follow-up" onChange={(e) => onChangeAdditionalTextFollowUp(e)} />
                     
                     
                        <div class="text-center mb-20 mt-2" style={{display:'flex',gap:'5px',justifyContent:'flex-end',gap:'5px'}}>
                                             <Button2 type="dark" children={'Cancel'} onClickFunc={()=>advanceFilterModalToggle({ bool: false, value: "" })} />
                                             <Button2 type="dark" children='Ask the Team' onClickFunc={()=>askTheTeamPayloadData()} />
                                             <Button onClickFunc={()=>followUpPayloadData()} type={'primary'} text={`Ask${" "}${selectedAns.selectedAnswer.expertFirstName}`} />
                                         </div>
                  
                    </div>
                </Spin>
            </ModalBody>
        </Modal>
    )
}